module.exports = __webpack_public_path__ + "static/media/ysl.6d3eb453.jpg";